import { render, staticRenderFns } from "./teacherTotal.vue?vue&type=template&id=075d8539&scoped=true&"
import script from "./teacherTotal.vue?vue&type=script&lang=js&"
export * from "./teacherTotal.vue?vue&type=script&lang=js&"
import style0 from "./teacherTotal.vue?vue&type=style&index=0&id=075d8539&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "075d8539",
  null
  
)

export default component.exports